module.exports = __webpack_public_path__ + "static/media/color.362afbb1.svg";